var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { OutsourceBackCService } from "~/services/domain-service/outsource-backc-manage.service";
import ModifyParameter from "~/components/system-manage/param-manage/modify-parameter.vue";
import { CityService } from "~/utils/city.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var BackCManageIndex = /** @class */ (function (_super) {
    __extends(BackCManageIndex, _super);
    function BackCManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queryModel = {
            outBatch: "",
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            localAddress: "",
            currentCollector: "",
            overduePeriod: "",
            turnSource: "",
            FollowupBack: "",
            productCategory: "",
            productName: "",
            area: "",
            followupBack: "",
            outAmount: {
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overdueDays: {
                max: "",
                min: ""
            },
            followInTime: [],
            labelName: []
        };
        _this.proinviceList = []; // 省
        _this.cityList = []; //市
        _this.dataList = [];
        _this.dialog = {
            modifysysparamterDialog: false
        };
        _this.modifyData = {};
        _this.refresh = {};
        return _this;
    }
    BackCManageIndex.prototype.mounted = function () {
        this.refreshData();
        this.getProvinces();
    };
    //获取省数据
    BackCManageIndex.prototype.getProvinces = function () {
        this.proinviceList = CityService.getCityData({ level: 1 });
    };
    //获取市
    BackCManageIndex.prototype.getCitys = function (provinceId) {
        if (this.queryModel.cityCode) {
            this.queryModel.cityCode = "";
        }
        this.cityList = this.$city.getCityData({ level: 1, id: provinceId }); // 城市列表
    };
    BackCManageIndex.prototype.refreshData = function () {
        var _this = this;
        this.outsourceBackCService
            .getCaseBackCPoolPageList(this.queryModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataList = data;
        });
    };
    /**
     * 修改
     */
    BackCManageIndex.prototype.editDetail = function (scope) { };
    /**
     * 查看
     */
    BackCManageIndex.prototype.checkDetail = function (scope) { };
    /**
     * 修改open事件 ，获取要修改的当前行数据
     */
    BackCManageIndex.prototype.getmodifyData = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.refresh = _this.$refs["refresh"];
            _this.refresh.refresh(_this.modifyData);
        });
    };
    /**
     * 进入查看执行页
     */
    BackCManageIndex.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Outsource_turn,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 重置numberRange
     */
    BackCManageIndex.prototype.follFeedback = function () {
        this.queryModel.outAmount = { min: "", max: "" };
        this.queryModel.overdueDays = { min: "", max: "" };
        this.queryModel.proinviceCode = "";
        this.queryModel.cityCode = "";
        this.queryModel.caseMoney = { min: "", max: "" };
    };
    __decorate([
        Dependencies(OutsourceBackCService)
    ], BackCManageIndex.prototype, "outsourceBackCService", void 0);
    __decorate([
        Dependencies(PageService)
    ], BackCManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], BackCManageIndex.prototype, "sortService", void 0);
    BackCManageIndex = __decorate([
        Auth(1004),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                ModifyParameter: ModifyParameter
            }
        })
    ], BackCManageIndex);
    return BackCManageIndex;
}(Vue));
export default BackCManageIndex;
